import Reflux from 'reflux';
import { QuizDetailActions, AppActions } from 'actions';
import debounce from 'oxygen-debounce';
import SteelCompass from 'services/SteelCompass';
import { translate as _l } from 'oxygen-i18n';

addTranslations({
  ['en-US']: {
    'Quiz statistics will be generated and mailed to your email addresss.':
      'Quiz statistics will be generated and mailed to your email addresss.'
  },
  ['sv-SE']: {
    'Quiz statistics will be generated and mailed to your email addresss.':
      'Quizstatestik kommer att skickas till din e-postadress.'
  }
});

const QuizDetailStore = Reflux.createStore({
  listenables: [QuizDetailActions],
  data: {
    filters: {
      courseId: null,
      userId: null
    },
    pages: {
      selectedPage: null,
      list: [],
      entities: {},
      loading: false
    },
    students: {
      selectedStudent: null,
      loading: false,
      entities: {},
      list: []
    },
    courses: {
      selectedCourse: null,
      list: [],
      expanded: true,
      entities: {},
      filter: null,
      loading: false
    },
  },
  quiz: {
    quizData: [],
    quizStudents: [],
    studentData: null
  },
  getInitialState() {
    return this.data;
  },
  start() {
    QuizDetailActions.findCourses()
  },
  loading(listName = 'pages', loading = true) {
    this.data = {
      ...this.data,
      [listName]: {
        ...this.data[listName],
        loading
      }
    };
    this.trigger(this.data);
    this.trigger(this.quiz);
  },
  resetPage(id, locked, selectedPage, quizData) {
    quizData.forEach((el, i) => {
      if (el.id === selectedPage) {
        const userdata = el.userdata[id];
        this.quiz.quizData[i] = el;
        this.quiz.quizData[i].userdata[id].locked = locked;
        this.trigger(this.quiz);
        return SteelCompass.request('content', 'saveDataForObject', {
          objectId: Number(selectedPage),
          objectType: 'page',
          userId: id,
          data: {
            ...userdata,
            locked,
          },
        })
      }
    })
  },
  selectPage(id) {
    this.data.pages.selectedPage = id;
    this.data.students.selectedStudent = null;
    this.trigger(this.data);
  },
  // selectCourse(id) {
  //   this.data.courses.selectedCourse = id;
  //   this.data.pages.selectedPage = null;
  //   this.data.students.selectedStudent = null;
  //   this.trigger(this.data);
  //   QuizDetailActions.readQuizzes(id);
  // },
  // selectUser(id, pageLength) {
  //   this.data.students.selectedStudent = id;
  //   this.trigger(this.data);
  //   QuizDetailActions.readQuizzes(this.data.courses.selectedCourse, id, 0, pageLength);
  // },
  selectUser: debounce(function readUserDebounced(courseId = null, userId = null, pageStart = 0, pageLength = 20) {
    this.loading();
    return SteelCompass.request('quiz', 'read', { courseId, userId }, pageStart, pageLength).then(
      data => {
        this.quiz.studentData = data;
        this.trigger(this.quiz)
      },
      error => {
        this.loading('pages', false);
        AppActions.genericError(error);
      }
    );
  }, 500),
  selectCourse: debounce(function readQuizzesDebounced(courseId = null, userId = null, pageStart = 0, pageLength = 20, callback) {
    this.loading();
    SteelCompass.request('quiz', 'read', { courseId, userId }, pageStart, pageLength).then(data => {
      if (!Object.keys(data).length) {
        return;
      }
      if (pageStart === 0) {
        this.quiz.quizData = data;
      } else {
        this.quiz.quizData = { ...this.quiz.quizData, ...data };
      }
      this.trigger(this.quiz);
      callback && callback(data);
    }, error => {
      this.loading('pages', false);
      AppActions.genericError(error);
      callback && callback([]);
    })

  }, 500),
  readQuizzes: debounce(function readTasksDebounced(courseId = null, userId = null, pageStart = 0, pageLength = 20) {
    this.loading();
    return SteelCompass.request('quiz', 'read', { courseId, userId }, pageStart, pageLength).then(
      data => {
        this.readQuizComplete(data, userId);
      },
      error => {
        this.loading('pages', false);
        AppActions.genericError(error);
      }
    );
  }, 500),
  // findTaskStudents(courseId) {
  //   this.loading('students');
  //   return SteelCompass.request('user', 'findByCourseId', {
  //     courseId,
  //     showCourses: true,
  //     sortBy: 'name',
  //     sortMode: 'asc'
  //   }, 0, 1100).then(
  //     students => {
  //       this.findTaskStudentsComplete(students);
  //     },
  //     error => {
  //       this.loading('students', false);
  //       AppActions.genericError(error);
  //     }
  //   );
  // },
  findTaskStudents(courseId) {
    this.loading('students');
    return SteelCompass.request('user', 'findByCourseId', {
      courseId,
      showCourses: true,
      sortBy: 'name',
      sortMode: 'asc'
    }, 0, 1100).then(
      students => {
        this.quiz.quizStudents = students;
        this.trigger(this.quiz);
      },
      error => {
        this.loading('students', false);
        AppActions.genericError(error);
      }
    );
  },
  findCourses() {
    this.loading('courses');
    return SteelCompass.request('course', 'findBuildable', { filters: [{ mode: 'hasQuiz', value: true }] }).then(
      courses => {
        this.findTaskCoursesComplete(courses);
      },
      error => {
        this.loading('courses', false);
        AppActions.genericError(error);
      }
    );
  },
  export(email) {
    return SteelCompass.request('quiz', 'export', { recipientEmail: email }).then(
      courses => {
        AppActions.notify(
          _l`Quiz statistics will be generated and mailed to your email addresss.`
        );
      },
      error => {
        AppActions.genericError(error);
      }
    );
  },
  getEntities(input) {
    const list = [];
    const entities = {};
    input.forEach(item => {
      list.push(item.id);
      entities[item.id] = item;
    });
    return {
      list,
      entities
    };
  },
  findTaskCoursesComplete(list) {
    this.data = {
      ...this.data,
      courses: {
        ...this.data.courses,
        loading: false,
        ...this.getEntities(list)
      }
    };
    this.trigger(this.data);
  },
  findTaskStudentsComplete(list) {
    this.data = {
      ...this.data,
      students: {
        ...this.data.students,
        loading: false,
        ...this.getEntities(list)
      }
    };
    this.trigger(this.data);
  },

  readQuizComplete(entities, id) {
    this.data = {
      ...this.data,
      pages: {
        ...this.data.pages,
        list: Object.keys(entities),
        entities: {
          [this.data.pages.selectedPage]: {
            ...entities[this.data.pages.selectedPage],
            ...this.data.pages.entities[this.data.pages.selectedPage],
          },
          ...this.data.pages.entities,
          ...entities,
        },
        loading: false
      }
    };
    // console.log(this.data, 'check data')
    this.trigger(this.data);
  }
});

export default QuizDetailStore;



// WEBPACK FOOTER //
// ./src/js/stores/QuizDetail.js